module.exports = __webpack_public_path__ + "69869fb2184b931a98b71e48cbaf0f82.MP3";